import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

// Pipes
import { DisplayValuePipe } from "./pipes/display-value.pipe";
import { PercentagePipe } from "./pipes/percentage.pipe";
import { CurrencyFormatterPipe } from "./pipes/currency-formatter.pipe";
import { SafeImageSrcPipe } from "./pipes/safe-image-src.pipe";
import { NameCasePipe } from "./pipes/name-case.pipe";

// Components
import { ImageModalComponent } from "./components/image-modal/image-modal.component";
import { DsConfirmDialogComponent } from "./components/ds-confirm-dialog/ds-confirm-dialog.component";
import { EmptyStateComponent } from "./components/empty-state/empty-state.component";

// Services
import { ImageModalService } from "./services/image-modal.service";

// Angular Material
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

const PIPES = [
	DisplayValuePipe,
	PercentagePipe,
	CurrencyFormatterPipe,
	SafeImageSrcPipe,
];

const COMPONENTS = [
	ImageModalComponent,
	DsConfirmDialogComponent,
];

const MATERIAL_MODULES = [MatDialogModule, MatButtonModule, MatIconModule];

@NgModule({
	declarations: [...PIPES, ...COMPONENTS],
	imports: [
		CommonModule,
		TranslateModule,
		...MATERIAL_MODULES,
		NameCasePipe,
		EmptyStateComponent,
	],
	exports: [
		...PIPES,
		...COMPONENTS,
		...MATERIAL_MODULES,
		CommonModule,
		TranslateModule,
		NameCasePipe,
		EmptyStateComponent,
	],
	providers: [ImageModalService],
})
export class SharedModule {}
